import { Injectable, inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { InteractionRequiredAuthError, BrowserAuthError, BrowserAuthErrorCodes } from '@azure/msal-browser';
import { jwtDecode } from 'jwt-decode';
import { firstValueFrom } from 'rxjs';
import { ConfigService } from 'src/config';

interface JwtToken {
  roles?: string[];
}

@Injectable({
  providedIn: 'root'
})
export class UserRoleService {
  private readonly _msalService = inject(MsalService);
  private readonly _configService = inject(ConfigService);


  constructor() {}

  async isTaWriter(): Promise<boolean> {
    return this.hasRole('Writer', [this._configService.taApiScope]);
  }

  async isTaTemplateEditor(): Promise<boolean> {
    return this.hasRole('TemplateEditor', [this._configService.taApiScope]);
  }

  async hasRole(roleName: string, scopes: string[]): Promise<boolean> {
    try {
      const account = this._msalService.instance.getActiveAccount();
      if (!account) return false;

      const token = await firstValueFrom(this._msalService.acquireTokenSilent({
        scopes: scopes,
        account: account,
        redirectUri: window.location.origin + '/blank'
      }));

      const decodedToken = jwtDecode<JwtToken>(token.accessToken);
      return decodedToken.roles?.includes(roleName) ?? false;
    } catch (error) {
      // Handle interaction required - but avoid triggering if already in progress
      if (error instanceof InteractionRequiredAuthError) {
        if (error.errorCode !== BrowserAuthErrorCodes.interactionInProgress) {
          this._msalService.acquireTokenRedirect({
            scopes: scopes,
            redirectUri: window.location.origin + '/blank'
          });
        }
      } else if (error instanceof BrowserAuthError) {
        // Log other MSAL errors but don't throw
        console.warn('MSAL error in hasRole:', error.errorCode, error.errorMessage);
      }

      return false;
    }
  }
}